import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexSettlementsRequest = ({ dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', '/settlements', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const createSettlementRequest = ({ dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('post', '/settlements', {
    dispatch,
    params,
    formData,
    successCallback,
    callback,
    service: 'payroll'
  });

export const showSettlementRequest = (id, { dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', `/settlements/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const updateSettlementRequest = (id, { dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('put', `/settlements/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    callback,
    service: 'payroll'
  });

export const calculateSettlementRequest = ({ dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('post', `/settlements/calculate`, {
    dispatch,
    params,
    formData,
    successCallback,
    callback,
    service: 'payroll'
  });

export const deleteSettlementRequest = (id, { dispatch, successCallback, callback, failureCallback }) =>
  ApiService.request('delete', `/settlements/${id}`, {
    dispatch,
    successCallback,
    failureCallback,
    callback,
    service: 'payroll'
  });

export const payrollRequest = ({ dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', '/payrolls', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const payrollSettlementRequest = ({ dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', '/payrolls/payroll_settlement', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const settlementSettingsRequest = ({ dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', '/settlement_settings', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const getEmployeeBalances = ({ dispatch, params = {}, failureCallback, successCallback, callback }) =>
  ApiService.request('get', `/payroll_balance_employees/employee_balances`, {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback,
    service: 'payroll'
  });

export const getEmployeeBalancesSettlement = ({ dispatch, params = {}, failureCallback, successCallback, callback }) =>
  ApiService.request('get', `/payroll_balance_employees/employee_balances_settlement`, {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback,
    service: 'payroll'
  });

export const generateSettlementDocument = (id, { dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('post', `/settlements/${id}/generate_settlement_document`, {
    dispatch,
    params,
    formData,
    successCallback,
    callback,
    service: 'payroll'
  });

export const variableBalanceRequest = ({ dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', '/payroll_balance_employees/variable_balances', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const massiveDestroySettlementsRequest = ({ dispatch, params, successCallback, callback }) =>
  ApiService.request('delete', '/settlements/massive_destroy', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const exportSettlementsRequest = ({ dispatch, params, successCallback, callback, format }) =>
  ApiService.request('get', `/settlements/export${format}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const debounceIndexSettlementsRequest = AwesomeDebouncePromise(indexSettlementsRequest, 300);
